import { MouseEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getSpecialisation } from "../../../redux/actions/job_action";
import {
  openSpecialisationDropdown,
  openSubSpecialisationDropdown,
  updateSubSpecialisation,
} from "../../../redux/actions/user_action";
import { SubSpecialisation } from "./SubSpecialisation";
import {
  ArrowDropDownIconStyled,
  ArrowDropUpIconStyled,
  ArrowRightIconStyled,
  BoxStyled,
  ButtonStyled,
  ErrorSpecialisationText,
  ErrorTextBox,
  IconButtonStyled,
  KeyboardArrowDownIconStyled,
  KeyboardArrowUpIconStyled,
  MajorCategoryItemText,
  MajorSpecialisationBox,
  MajorSpecialisationItem,
  MajorSpecialisationScrollBar,
  MenuStyled,
  SelectedSpecialisationText,
  TitleStyled,
  ValidationText,
} from "./styles";

export function MajorSpecialisation(props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const classes = MajorSpecialisationScrollBar();
  const {
    value,
    specialisationHandler,
    roundedRectangle,
    containerSx,
    error,
    errorText,
  } = props;
  const { t } = useTranslation();
  const specialisations = useSelector(
    (state: any) => state?.jobs?.specialisation
  );
  const dropdownState = useSelector(
    (state: any) =>
      state?.user?.openSpecialisationDropdown?.openSpecialisationDropdown
  );
  const subSpecialisationDropdown = useSelector(
    (state: any) =>
      state?.user?.openSubSpecialisationDropdown?.openSubSpecialisationDropdown
  );
  const dispatch: any = useDispatch();

  useEffect(() => {
    dispatch(getSpecialisation());
  }, []);

  function handleClick(event: MouseEvent<HTMLButtonElement>) {
    setAnchorEl(event.currentTarget);
    dispatch(openSpecialisationDropdown(true));
    dispatch(openSubSpecialisationDropdown(false));
  }

  function handleClose() {
    setAnchorEl(null);
    dispatch(openSubSpecialisationDropdown(false));
  }

  function handleClickMajorSpecialisation(index: number) {
    dispatch(openSubSpecialisationDropdown(true));
    dispatch(updateSubSpecialisation(specialisations[index]));
  }

  const arrowUpIcon = roundedRectangle ? (
    <ArrowDropUpIconStyled />
  ) : (
    <KeyboardArrowUpIconStyled />
  );
  const arrowDownIcon = roundedRectangle ? (
    <ArrowDropDownIconStyled />
  ) : (
    <KeyboardArrowDownIconStyled />
  );
  const getSpecialisationLabel = (specialisationValue?: string) => {
    if (!specialisationValue) return "";
    const key = specialisationValue
      .toString()
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");
    return t(`companydetail.specialisation_labels.${key}`, {
      defaultValue: specialisationValue,
    });
  };

  return (
    <BoxStyled sx={containerSx}>
      <TitleStyled smallMarginBottom={roundedRectangle}>
        {t("overview.specialisation")}
      </TitleStyled>

      <ButtonStyled
        onClick={handleClick}
        open={open}
        error={error}
        roundedRectangle={roundedRectangle}
        disableRipple
        disableFocusRipple
      >
        <SelectedSpecialisationText $value={value ? "true" : "false"}>
          {value ? getSpecialisationLabel(value) : t("overview.please_select")}
        </SelectedSpecialisationText>
        <IconButtonStyled disableRipple>
          {open ? arrowUpIcon : arrowDownIcon}
        </IconButtonStyled>
      </ButtonStyled>
      {error ? (
        <ValidationText style={{ marginTop: "3px", marginLeft: "14px" }}>
          {errorText ?? t("overview.specialisation_required")}
        </ValidationText>
      ) : null}

      <MenuStyled
        hasMaxWidth={roundedRectangle}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        transitionDuration={0}
      >
        {subSpecialisationDropdown ? (
          <SubSpecialisation
            setAnchorEl={setAnchorEl}
            specialisationHandler={specialisationHandler}
          />
        ) : null}

        {dropdownState ? (
          <MajorSpecialisationBox className={classes.scrollBar}>
            {specialisations ? (
              specialisations?.map((specialisation, index) => (
                <MajorSpecialisationItem
                  key={specialisation?.id}
                  // @ts-ignore
                  onClick={() => handleClickMajorSpecialisation(index)}
                >
                  <MajorCategoryItemText>
                    {getSpecialisationLabel(specialisation?.name)}
                  </MajorCategoryItemText>
                  <ArrowRightIconStyled />
                </MajorSpecialisationItem>
              ))
            ) : (
              <ErrorTextBox>
                <ErrorSpecialisationText>
                  {t("overview.specialisation_load_failed")}
                </ErrorSpecialisationText>
              </ErrorTextBox>
            )}
          </MajorSpecialisationBox>
        ) : null}
      </MenuStyled>
    </BoxStyled>
  );
}
